import { render, staticRenderFns } from "./examSeason.vue?vue&type=template&id=0bc5313c&scoped=true&"
import script from "./examSeason.vue?vue&type=script&lang=js&"
export * from "./examSeason.vue?vue&type=script&lang=js&"
import style0 from "./examSeason.vue?vue&type=style&index=0&id=0bc5313c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5313c",
  null
  
)

export default component.exports